<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('report.arList') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('home'), href: '/' },
          {
            text: $t('report.arList'),
            active: true,
          },
        ]"
      />
    </div>
    <div class="row">
      <div class="col-md-12">
        <ts-card>
          <ts-card-wrapper>
            <form class="form-horizontal">
              <fieldset>
                <legend class="text-black">
                  {{ $t('report.criteriaFilter') }}
                </legend>
                <div class="row">
                  <div class="col-sm-12 col-lg-4 col-md-6">
                    <div class="form-group row">
                      <label
                        class="col-md-3 form-col-label control-label required"
                        >{{ $t('report.date') }}</label
                      >
                      <div class="col-md-9">
                        <a-range-picker
                          class="ts-w-full"
                          valueFormat="DD-MM-YYYY"
                          format="DD-MM-YYYY"
                          v-model="model.date"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-12 col-lg-4 col-md-6">
                    <div class="form-group row">
                      <div class="col-md-8">
                        <ts-button
                          color="info"
                          class="mr-2"
                          outline
                          :waiting="preview_load"
                          @click.prevent="onPreview"
                          >{{ $t('preview') }}</ts-button
                        >
                        <ts-button
                          color="success"
                          outline
                          :waiting="downloading"
                          @click.prevent="onDownload"
                        >
                          <i class="far fa-file-excel"></i>
                          {{ $t('export') }}</ts-button
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </fieldset>
            </form>
          </ts-card-wrapper>
          <div id="list" class="ts-overflow-scroll">
            <ts-table
              :columns="columns"
              :records="resources"
              :loading="preview_load"
            >
              <template v-slot="{ record }">
                <td class="ts-whitespace-no-wrap">
                  {{ record.seller_name }}
                </td>
                <td class="ts-whitespace-no-wrap">
                  {{ record.agent_type }}
                </td>
                <td class="ts-whitespace-no-wrap">
                  {{ record.phone_no }}
                </td>
                <td class="ts-whitespace-no-wrap text-right">
                  {{ record.start_balance }}
                </td>
                <td class="ts-whitespace-no-wrap text-right">
                  {{ record.topup_amount }}
                </td>
                <td class="ts-whitespace-no-wrap text-right">
                  {{ record.credit_available }}
                </td>
                <td class="ts-whitespace-no-wrap text-right">
                  {{ record.gross_sale }}
                </td>
                <td class="ts-whitespace-no-wrap text-right">
                  {{ record.cancel_amount }}
                </td>
                <td class="ts-whitespace-no-wrap text-right">
                  {{ record.net_sale }}
                </td>
                <td class="ts-whitespace-no-wrap text-right">
                  {{ record.sale_commission }}
                </td>
                <td class="ts-whitespace-no-wrap text-right">
                  {{ record.payout_amount }}
                </td>
                <td class="ts-whitespace-no-wrap text-right">
                  {{ record.pay_commission }}
                </td>
                <td class="ts-whitespace-no-wrap text-right">
                  {{ record.withdrawal_amount }}
                </td>
              </template>
            </ts-table>
          </div>
          <ts-card-wrapper>
            <div class="d-flex justify-content-end p-15">
              <ts-pagination
                v-model="pagination"
                @navigate="onPreview"
              ></ts-pagination>
            </div>
          </ts-card-wrapper>
        </ts-card>
      </div>
    </div>
  </div>
</template>
<script>
import * as FileDownload from 'downloadjs'
import moment from 'moment'
import { mapActions, mapState } from 'vuex'
import { Errors } from 'form-backend-validation'

export default {
  name: 'arList',
  data() {
    return {
      errors: new Errors(),
      loading: false,
      preview_load: false,
      downloading: false,
      model: {
        date: [moment().format('DD-MM-YYYY'), moment().format('DD-MM-YYYY')],
      },
    }
  },
  created() {
    this.fetchData()
  },
  computed: {
    ...mapState('report/arList', ['resources', 'pagination']),
    columns() {
      return [
        { name: this.$t('report.sellerName') },
        { name: this.$t('report.agentType') },
        { name: this.$t('report.phone') },
        { name: this.$t('report.startBalance'), style: 'text-align: right' },
        { name: this.$t('report.topupAmount'), style: 'text-align: right' },
        { name: this.$t('report.creditAvailable'), style: 'text-align: right' },
        { name: this.$t('report.grossSale'), style: 'text-align: right' },
        { name: this.$t('report.cancelAmount'), style: 'text-align: right' },
        { name: this.$t('report.netSale'), style: 'text-align: right' },
        { name: this.$t('report.saleCommission'), style: 'text-align: right' },
        { name: this.$t('report.payoutAmount'), style: 'text-align: right' },
        { name: this.$t('report.payCommission'), style: 'text-align: right' },
        {
          name: this.$t('report.withdrawalAmount'),
          style: 'text-align: right',
        },
      ]
    },
  },
  methods: {
    ...mapActions('report/arList', ['preview', 'store']),
    onPreview(attributes) {
      this.errors = new Errors()
      this.preview_load = true
      this.preview(
        Object.assign(
          {},
          {
            date_from: this.model.date[0],
            date_to: this.model.date[1],
          },
          attributes
        )
      )
        .catch((error) => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.preview_load = false
        })
    },
    onDownload() {
      this.errors = new Errors()
      this.downloading = true
      this.store({
        date_from: this.model.date[0],
        date_to: this.model.date[1],
      })
        .then((response) => {
          FileDownload(response, 'ar_list_report.xlsx')
        })
        .catch((errorData) => {
          let error = JSON.parse(
            String.fromCharCode.apply(null, new Uint8Array(errorData))
          )
          this.errors = new Errors(errorData.errors)
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.downloading = false
        })
    },
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('report/arList/RESET_STATE')
    next()
  },
}
</script>

<style lang="css" scoped>
#list {
  min-height: 50vh;
  max-height: 60vh;
}
</style>